import React from 'react';

const Tiles = props => {
    return (
        <React.Fragment>
            <div style={{ marginTop: '0px' }}>
                {!props.hideLabel && <div className="row">
                    <div className="col-md-12">
                        <h6 className="text-app text-bold pl-2">{props.header.label}</h6>
                        <span className="text-app pl-2 font-size-13">{props.header.description}</span>
                    </div>
                </div>}
                <div className="row mt-2">
                    {props.reports.map((report, index) => (
                        <div key={index} className="col-md-3">
                            <div className="card m-2 bg-shadow">
                                <div className="card-body">
                                    <span className="fa-2x">{report.pic}</span>
                                    <div className="text-app mt-3"><b>{report.name}</b></div>
                                    <div className="text-app mt-2" style={{ minHeight: '70px' }}>{report.description}</div>
                                </div>
                                <div className="card-footer bg-light border-0">
                                    {report.report}
                                    {report.savedReports && report.savedReports}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </React.Fragment>
    );
}
export default Tiles;